import React from "react";

const getLi = () => {
  return termsArray.map(text => (
    <li
      style={{
        display: "block",
        backgroundColor: "white",
        margin: "0px",
        marginBottom: "10px",
        padding: "10px"
      }}
    >
      {text}
    </li>
  ));
};

const termsArray = [
  "This is an online delivery service",
  "We are not charging any commission and the price you pay goes direct to supplier",
  "We strive our best to deliver as soon as possible, within 2/3 days, however we are getting overwhelmed by orders and our suppliers also require time for packaging",
  "For any urgent requests or follow-up please contact Kabir Hossain(Cell: 94562455)",
  "Please ensure to comply with all prevailing laws and safety precautions requirements that are relevant for circuit breaker.",
  "Please refer to https://www.moh.gov.sg/covid-19 for updates on current situation as well as latest updates.",
  "In these times, it is the responsibility of every individual to comply with social distancing, quarantine or circuit breaker rules. Though we strive our best to provide enough understanding of required rules/laws to our suppliers/drivers, it is as such, an individual's own responsibility to ensure compliance at all times.",
  "Please use the special instructions box provided in the order to inform upfront if you are currently in quarantine or if you tested positive or if you were in close contact with any one who tested positive. Please also inform the supplier of this when you are contacted back so that a contact less delivery is arranged while complying with any other required rules.",
  "This service is currently actively available in Singapore"
];

const termsMainPage = () => {
  return (
    <div>
      <div>
        <h2
          style={{
            marginTop: "5px",
            fontSize: "22px",
            fontWeight: "bold",
            textTransform: "uppercase",
            textAlign: "center"
          }}
        >
          TERMS AND CONDITIONS
        </h2>
        <div
          style={{
            fontSize: "15px",
            color: "grey",
            marginTop: "15px"
          }}
        ></div>
        <div style={{ margin: "5px" }}>
          <lu>{getLi()}</lu>
        </div>
      </div>
    </div>
  );
};

export default termsMainPage;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/termsMainPage.jsx